/* global insideFrontInterface */

const closeChatPane = () => {
    if (
        typeof insideFrontInterface !== 'undefined' &&
        insideFrontInterface.chat &&
        insideFrontInterface.chat.closeChatPane &&
        typeof insideFrontInterface.chat.closeChatPane === 'function'
    ) {
        insideFrontInterface.chat.closeChatPane();
    }
};

module.exports = {
    closeChatPane
};
